import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ListingQualityStatusService } from '../listing-quality-status.service';
import { ListingQualityStatus } from '../listing-quality-status';
import { ListingQualityStatusComponent } from '../listing-quality-status/listing-quality-status.component';
import { PropertyService } from '@app/_components/property/property.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-listing-quality-status-list',
    templateUrl: './listing-quality-status-list.component.html',
    styleUrls: ['./listing-quality-status-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ListingQualityStatusListComponent implements OnInit {
	properties: any;
	qualityTests: any;
	constructor(
		private propertyService: PropertyService,
		private listingQualityStatusService: ListingQualityStatusService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
	) {
		this.statuses = listingQualityStatusService.statuses
	}

	@Input() shortTermRentalIds = [];
	@Input() shortTermRentalId: any;

	// forms
	form1: UntypedFormGroup;

	// data
	listingQualityStatuss: any;
	listingQualityStatus: ListingQualityStatus;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	testResultStatusValues = [];
	testNameValues = [];

	// forms
	formLoading = false;

	statuses: any;

	validationMessages =
		{
			shortTermRentals: [],
		};

	columns: any[] = [
		{ field: 'testResultStatus', header: 'Test Result Status', width: 'auto' },
		{ field: 'shortTermRentalId', header: 'STRId', width: 'auto' },
		{ field: 'testSubjectName', header: 'Test Subject Name', width: 'auto' },
		{ field: 'testName', header: 'Test Name', width: 'auto' },
		{ field: 'testResultValue', header: 'Test Result Value', width: 'auto' },
		{ field: 'testResultDesc', header: 'Test Result Description', width: 'auto' },
	];

	ngOnInit(): void {
		this.fetchTestResultStatusValues();
		this.fetchTestNameUniqueValues();
		this.formBuild();
		this.fetchProperties();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			// console.log('Error: ' + error);
		}
		/*this.form1.patchValue({
			shortTermRentals: this.shortTermRentalId,
		});*/
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		// console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.qualityTestId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-listingQualityStatus-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.shortTermRentalId)
			{
				// show only shortTermRentals that are assigned to this shortTermRentalIdFilter
				let shortTermRentalIdFilter = { 'shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
				Object.assign(event.filters, shortTermRentalIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.listingQualityStatusService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						// console.log("res res : " + JSON.stringify(res));
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.listingQualityStatuss = res.data.qualityTests;
						// console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						// console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.listingQualityStatuss = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			// console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		// console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(listingQualityStatus: ListingQualityStatus) {
		try {
			this.formLoading = true;
			this.listingQualityStatusService.update(listingQualityStatus)
				.subscribe(
					(res: any) => {
						// console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.listingQualityStatuss.map((listingQualityStatus, i) => {
							if (listingQualityStatus.qualityTestId === res.data.listingQualityStatus.qualityTestId) {
								this.listingQualityStatuss[i] = res.data.listingQualityStatus;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						// console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(listingQualityStatus: any) {
		try {
			// stop here if form is invalid
			// console.log('Delete Submitted: ' + JSON.stringify(listingQualityStatus));

			this.formLoading = true;
			this.listingQualityStatusService.delete(listingQualityStatus.qualityTestId)
				.subscribe(
					(res: any) => {
						// console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.listingQualityStatuss.splice(this.listingQualityStatuss.indexOf(listingQualityStatus), 1);
						this.recordTotal = this.listingQualityStatuss.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ListingQualityStatus ' + listingQualityStatus.qualityTestId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						// console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ListingQualityStatus ' + listingQualityStatus.qualityTestId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Listing Quality Status'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ListingQualityStatusComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addListingQualityStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(listingQualityStatus: ListingQualityStatus) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			listingQualityStatus: listingQualityStatus,
			title: 'Edit Listing Quality Status'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ListingQualityStatusComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateListingQualityStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteListingQualityStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addListingQualityStatusCB(listingQualityStatus: ListingQualityStatus) {
		// console.log('Adding ListingQualityStatus: ' + JSON.stringify(listingQualityStatus));
		// if we don't have a listingQualityStatuss array yet...
		if (!this.listingQualityStatuss) {
			this.listingQualityStatuss = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.listingQualityStatuss.unshift(listingQualityStatus);

		// no idea what this is but it is required to update the array
		this.listingQualityStatuss = [...this.listingQualityStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ListingQualityStatus ' + listingQualityStatus.qualityTestId + ' Added', life: 3000 });
	}

	updateListingQualityStatusCB(listingQualityStatus: ListingQualityStatus) {
		// console.log('Updating ListingQualityStatus: ' + JSON.stringify(listingQualityStatus));
		let itemIndex = this.listingQualityStatuss.findIndex((item: any) => item.qualityTestId === listingQualityStatus.qualityTestId);
		this.listingQualityStatuss[itemIndex] = listingQualityStatus;

		// no idea what this is but it is required to update the array
		this.listingQualityStatuss = [...this.listingQualityStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ListingQualityStatus ' + listingQualityStatus.qualityTestId + ' Updated', life: 3000 });
	}

	deleteListingQualityStatusCB(listingQualityStatus: ListingQualityStatus) {
		// console.log('Removing ListingQualityStatus: ' + listingQualityStatus);
		this.listingQualityStatuss.splice(this.listingQualityStatuss.indexOf(listingQualityStatus), 1);
		this.recordTotal = this.listingQualityStatuss.length;

		// no idea what this is but it is required to update the array
		this.listingQualityStatuss = [...this.listingQualityStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ListingQualityStatus ' + listingQualityStatus.qualityTestId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.listingQualityStatuss ? this.first === (this.listingQualityStatuss.length - this.rows) : true; }
	isFirstPage(): boolean { return this.listingQualityStatuss ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(listingQualityStatus: any) {
		if (listingQualityStatus?.status) {
			const status = this.statuses.find((e: any) => e.value == listingQualityStatus.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	testQualityStatus()
	{
		this.testRateQualityStatus();
		this.testListingQualityStatus();
	}

	testRateQualityStatus() {
		try {
			// console.log('testRateQualityStatus-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			if (this.form1.value.shortTermRentals != null) {
				for (let i = 0; i < this.form1.value.shortTermRentals.length; i++) {
					// if the shortTermRental List does not already contain the shortTermRentalId, add it.
					if (!this.shortTermRentalIds.includes(this.form1.value.shortTermRentals[i].shortTermRentalId)) {
						this.shortTermRentalIds.push(this.form1.value.shortTermRentals[i].shortTermRentalId);
					}
				}
				this.listingQualityStatusService.testRateQualityStatus(this.shortTermRentalIds)
					.subscribe(
						res => {
							// console.log('testRateQualityStatus: ' + JSON.stringify(res));
							this.formLoading = false;
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Listing quality run successfully.', life: 3000 });
							this.loadLazy(this.lazyLoadEvent);
							return this.properties;
						},
						err => {
							this.formLoading = false;
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
			}else{
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Property list is null, Please select property', life: 3000 });
			}
		} catch (error) {
			this.formLoading = false;
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: JSON.stringify(error), life: 3000 });
		}
	}

	testListingQualityStatus() {
		try {
			// console.log('testListingQualityStatus-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			if (this.form1.value.shortTermRentals != null) {
				for (let i = 0; i < this.form1.value.shortTermRentals.length; i++) {
					// if the shortTermRental List does not already contain the shortTermRentalId, add it.
					if (!this.shortTermRentalIds.includes(this.form1.value.shortTermRentals[i].shortTermRentalId)) {
						this.shortTermRentalIds.push(this.form1.value.shortTermRentals[i].shortTermRentalId);
					}
				}
				this.listingQualityStatusService.testListingQualityStatus(this.shortTermRentalIds)
					.subscribe(
						res => {
							// console.log('testListingQualityStatus: ' + JSON.stringify(res));
							this.formLoading = false;
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Listing quality run successfully.', life: 3000 });
							this.loadLazy(this.lazyLoadEvent);
							return this.properties;
						},
						err => {
							this.formLoading = false;
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
			}else{
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Property list is null, Please select property', life: 3000 });
			}
		} catch (error) {
			this.formLoading = false;
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: JSON.stringify(error), life: 3000 });
		}
	}

	testAllListingQualityStatus() {
		try {
			this.formLoading = true;
			this.listingQualityStatusService.testAllListingQualityStatus()
				.subscribe(
					res => {
						// console.log('testAllListingQualityStatus: ' + JSON.stringify(res));
						this.formLoading = false;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Listing all quality run successfully.', life: 3000 });
						this.loadLazy(this.lazyLoadEvent);
					},
					err => {
						this.formLoading = false;
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.formLoading = false;
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getResStatusColor(resStatus: any) {
		// console.log("resStatus :" + resStatus);
		if (resStatus === "WARN") {
			return '#FFD580';
		}
		if (resStatus === "PASS") {
			return '#32CD32';
		}
		if (resStatus === "FAIL") {
			return '#f16666 ';
		}
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							for (let i = 0; i < this.properties.length; i++) {
							    if(this.properties[i].shortTermRentalId == this.shortTermRentalId){
									this.form1.get('shortTermRentals').setValue([this.properties[i]]);
								}
							}
							return this.properties;
						},
						err => {
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				// console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// // console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			shortTermRentals: [],
		});
	}

	// get testName unique value for display into filter dropdown
	fetchTestResultStatusValues() {
		if (!this.testResultStatusValues || this.testResultStatusValues === undefined || this.testResultStatusValues.length < 1) {
			try {
				this.listingQualityStatusService.findTestResultStatusValues()
					.subscribe(
						res => {
							// console.log('findTestResultStatusValues: ' + JSON.stringify(res));
							for (var i = 0; i <= res.data.testResultStatus.length - 1; i++) {
								var kbmMapValueObj = {
									name: res.data.testResultStatus[i],
									value: res.data.testResultStatus[i]
								}
								this.testResultStatusValues.push(kbmMapValueObj);
							}
							return this.testResultStatusValues;
						},
						err => {
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				// console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// // console.log('properties are ' + this.properties);
			return (this.testResultStatusValues);
		}
	}

	// get testName unique value for display into filter dropdown
	fetchTestNameUniqueValues() {
		if (!this.testNameValues || this.testNameValues === undefined || this.testNameValues.length < 1) {
			try {
				this.listingQualityStatusService.findTestNameValues()
					.subscribe(
						res => {
							// console.log('findTestNameValues: ' + JSON.stringify(res));
							for (var i = 0; i <= res.data.testNames.length - 1; i++) {
								var kbmMapValueObj = {
									name: res.data.testNames[i],
									value: res.data.testNames[i]
								}
								this.testNameValues.push(kbmMapValueObj);
							}
							return this.testNameValues;
						},
						err => {
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				// console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// // console.log('properties are ' + this.properties);
			return (this.testNameValues);
		}
	}
}
